import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import ActivityProject from './AddTimeLog';
import ActivityProjectDetail from './ActivityProjectDetails';
import AddProject from './AddProject';

const ActivityLog = () => {
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isActivityDetailOpen, setIsActivityDetailOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    // Updated State Variables with Status
    const [activityLogs, setActivityLogs] = useState([
        { projectName: 'Website Development', customerName: 'ABC Corp', billingType: 'Hourly', price: '$500', view: 'View Details', status: 'Active' },
        { projectName: 'Mobile App', customerName: 'XYZ Ltd', billingType: 'Fixed', price: '$1500', view: 'View Details', status: 'Inactive' },
        { projectName: 'SEO Optimization', customerName: 'LMN Inc', billingType: 'Monthly', price: '$800', view: 'View Details', status: 'Active' },
    ]);

    const [filteredActivityLog, setFilteredActivityLog] = useState(activityLogs);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = activityLogs.filter((log) =>
            Object.values(log).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredActivityLog(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, activityLogs]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredActivityLog.length / itemsPerPage);
    const currentData = filteredActivityLog.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handlers for Edit and Delete actions
  

    // Toggle Status
    const toggleStatus = (index) => {
        setActivityLogs((prevLogs) =>
            prevLogs.map((log, i) =>
                i === index
                    ? { ...log, status: log.status === 'Active' ? 'Inactive' : 'Active' }
                    : log
            )
        );
    };


    const handleDelete = (index) => {
        const updatedLogs = activityLogs.filter((_, i) => i !== index);
        setActivityLogs(updatedLogs);
    };

    return (
        <>
                <div className="oms-header">
                    <h1 className="dashboard-title">Activity log</h1>

                    {/* Add Project Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Project
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Projects Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Project Name</th>
                                <th>Customer Name</th>
                                <th>Billing Type</th>
                                <th>Price</th>
                                <th>View</th>
                                <th>Status</th> {/* New Status Column */}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredActivityLog.length > 0 ? (
                                filteredActivityLog.map((log, index) => (
                                    <tr key={index}>
                                        <td>{log.projectName}</td>
                                        <td>{log.customerName}</td>
                                        <td>{log.billingType}</td>
                                        <td>{log.price}</td>
                                        <td>
                                            <button className="open-drawer-btn" onClick={() => setIsActivityDetailOpen(true)}>
                                                <i class="fa-solid fa-eye"></i>
                                            </button>
                                        </td>
                                        <td>
                                            <button onClick={() => toggleStatus(index)}>
                                                <i className={`fa ${log.status === 'Active' ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                            </button>
                                        </td>
                                        <td>
                                            <button className="edit-button" onClick={() => setIsModalOpen(true)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center' }}>
                                        No projects found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>

            <AddProject isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
            <ActivityProjectDetail isOpen={isActivityDetailOpen} onClose={() => setIsActivityDetailOpen(false)}
            />
        </>
    );
};

export default ActivityLog;
